import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { ApiBaseService } from './api-base.service';
import { SharedService } from './shared.service';
import { ScratchModel, ScratchStickerLinkModel } from '@shared/models/ScratchModel';
import { Country } from '@shared/models/Enums';

@Injectable()
export class ApiScratchService extends ApiBaseService {

    constructor(public http: HttpClient, public sharedService: SharedService) {
        super(http, sharedService);
    }

    // GET: api/admin/scratches/reads/v1/{id}
    getFullScratch(id: number, country: Country): Promise<ScratchModel> {

        return this.http.get(`${this.baseUrl}/api/admin/scratches/reads/v1/${id}`, this.getHttpOptionsWithoutSession(country))
            .toPromise().then(
                (result: any) => {

                    return new ScratchModel(result);
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de la raspadita: ${errMsg}`));
                }
            );
    }

    // GET: api/admin/scratches/sticker-link/reads/v1/{linkCode}
    getScratchStickerLink(linkCode: string, country: Country): Promise<ScratchStickerLinkModel> {

        return this.http.get(`${this.baseUrl}/api/admin/scratches/sticker-link/reads/v1/${linkCode}`, this.getHttpOptionsWithoutSession(country))
            .toPromise().then(
                (result: any) => {

                    return new ScratchStickerLinkModel(result);
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar la raspadita: ${errMsg}`));
                }
            );
    }
}
